import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../abstract/base.service';
import { OrganizationSeason } from '../data-models/organization-season.model';
import { OrganizationSeasonCreateRequest } from '../request-models/organization-season-create-request.model';
import { OrganizationSeasonUpdateRequest } from '../request-models/organization-season-update-request.model';
import { toOrganizationSeasonCreateRequest, toOrganizationSeasonUpdateRequest } from '../utils/organization-season-request-utils';

/**
 * An organization's spraying seasons: `/admin/organizations/:organizationId/seasons`
 * (hub `admin-organization-seasons-controller.ts`). The hub has no delete route.
 */
@Injectable({ providedIn: 'root' })
export class OrganizationSeasonService extends BaseService<OrganizationSeason> {
  constructor() {
    super('seasons', OrganizationSeason);
  }

  /** GET /admin/organizations/:organizationId/seasons */
  listSeasons(organizationId: string): Observable<OrganizationSeason[]> {
    return this.getMany({ prefix: organizationPrefix(organizationId) });
  }

  /** POST /admin/organizations/:organizationId/seasons */
  createSeason(organizationId: string, fields: OrganizationSeasonCreateRequest): Observable<OrganizationSeason | null> {
    return this.create(toOrganizationSeasonCreateRequest(fields), { prefix: organizationPrefix(organizationId) });
  }

  /** PUT /admin/organizations/:organizationId/seasons/:seasonId with only the fields that are set. */
  updateSeason(organizationId: string, seasonId: string, fields: OrganizationSeasonUpdateRequest): Observable<OrganizationSeason | null> {
    return this.update(seasonId, toOrganizationSeasonUpdateRequest(fields), { prefix: organizationPrefix(organizationId) });
  }
}

function organizationPrefix(organizationId: string): string[] {
  return ['admin', 'organizations', organizationId];
}
